import { PageFrame } from "./PageFrame";
import { useEffect } from "react";
import { showCustomError } from "@/error/ErrorManager";
import { CenteredErrorIcon } from "@/error/CenteredErrorIcon";

export const NotFound = () => {
    useEffect(() => {
        showCustomError({
            title: "Page not found"
        });
    }, []);

    return (
        <PageFrame breadcrumbReplacement={<></>}>
            <CenteredErrorIcon />
        </PageFrame>
    );
};
